import request from "@/utils/request"
import da from "element-ui/src/locale/lang/da"

//首页banner
export function getIndexBanner() {
  return request({
    url: `/api.php/Index/getIndexBanner`,
    method: "get",
  })
}

//市场商户
export function getMerchant(data) {
  return request({
    url: `/nm/system-merchant/detail`,
    method: "get",
    params: data,
  })
}
// 点赞
export function merchantLike(data) {
  return request({
    url: `/nm/merchant-like`,
    method: "post",
    data: data,
  })
}
// 投诉
export function merchantComplaint(data) {
  return request({
    url: `/nm/merchant-complaint`,
    method: "post",
    data: data,
  })
}

//商户食安检测分页
export function safety(data) {
  return request({
    url: `/nm/goods-safety/page`,
    method: "get",
    params: data,
  })
}

//市场管理人员信息
export function employeeList(data) {
  return request({
    url: `/nm/system-employee/list`,
    method: "get",
    params: data,
  })
}
